<template>
  <el-dialog
    v-if="visible"
    :visible="visible"
    width="800px"
    :title="title"
    show-close
    :close-on-click-modal="false"
    :before-close="() => close()"
    v-el-dialog-drag
  >
    <el-form ref="form" :model="formData" size="small" :rules="rules">
      <el-row :gutter="25">
        <el-col :span="24">
          <div class="side_frame_warning">
            <el-card
              shadow="never"
              style="background-color: #FFF6F7;border:0px"
            >
              <div slot="header">
                <span class="span_text_header"
                  >{{
                    $l('tips_series_selection_method_prompt') ||
                      '系列选择方式提示'
                  }}：</span
                >
              </div>
              <div class="span_text_body">
                {{
                  $l('tips_remind_one') ||
                    '1）使用新系列：系统自动从系列字典中随机抽取一个未使用的系列名称，用于当前SPU'
                }}
              </div>
              <div class="span_text_body mt-1">
                {{
                  $l('tips_remind_two') ||
                    '2）选择老系列：从已经使用过的系列下拉框中，手动选择一个系列名称，用于当前SPU'
                }}
              </div>
            </el-card>
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="6">
          <div>
            <el-radio-group v-model="radio" size="small" @change="radioChange">
              <el-radio-button label="A">
                {{ $l('btn_using_new_collection') || '使用新系列' }}
              </el-radio-button>
              <el-radio-button label="B">
                {{
                  $l('btn_choose_old_collection') || '选择老系列'
                }}</el-radio-button
              >
            </el-radio-group>
          </div>
        </el-col>

        <el-col :span="12">
          <el-form-item :label="''" prop="value">
            <dict-select
              v-model="formData.value"
              :url="url"
              :placeholder="$l('INDEX.form_label_selectseries') || '请选择系列'"
              :body="hxSkuCollectionParams"
              :selectedLabel.sync="formData.label"
              clearable
              filterable
              :disabled="chooseOldVisible"
              style="width:100%"
            ></dict-select>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <span slot="footer">
      <el-button size="small" @click="close()">
        {{ $l('INDEX.btn_cancel') || '取消' }}
      </el-button>
      <el-button type="primary" size="small" @click="confirm()">
        {{ $l('INDEX.btn_confirm') || '确认' }}
      </el-button>
    </span>
  </el-dialog>
</template>
<script>
import validate from '@/libs/util.validate'
export default {
  components: {},
  props: {
    visible: { type: Boolean, default: false },
    title: { type: String, default: '' },
    form: { type: Object, default: () => {} },
  },
  data() {
    return {
      formData: {},
      radio: 'A',
      chooseOldVisible: true,
      url: '',
      hxSkuCollectionParams: {
        brandCode: '',
        categoryCode: '',
        isVc: '',
        hxSpuCode: '',
      },
      rules: {
        value: [
          {
            required: true,
            message: this.$l('INDEX.form_label_selectseries') || '请选择系列',
            trigger: 'change',
          },
        ],
      },
    }
  },
  watch: {
    form: {
      handler(val) {
        if (val) {
          const { brandCode, categoryCode, isVc, hxSpuCode } = this.form
          this.hxSkuCollectionParams.brandCode = brandCode || ''
          this.hxSkuCollectionParams.categoryCode = categoryCode || ''
          this.hxSkuCollectionParams.isVc = isVc || ''
          this.hxSkuCollectionParams.hxSpuCode = hxSpuCode || ''
        }
      },
      immediate: true,
    },
  },
  methods: {
    async confirm() {
      if (this.radio === 'B') {
        const result = await validate.formValidate([this.$refs.form])
        if (!result) return
        this.$emit('confirm', this.formData || {})
        this.close()
      }
      if (this.radio === 'A') {
        this.$api
          .ecomHxSpuNewCollectionApi()
          .then((res) => {
            this.formData = res.body
            this.$emit('confirm', this.formData || {})
            this.close()
          })
          .catch(() => {})
      }
    },
    close() {
      this.$emit('update:visible', false)
      this.chooseOldVisible = true
      this.hxSkuCollectionParams = {}
    },
    radioChange(value) {
      if (value === 'A') this.useNew()
      if (value === 'B') this.userOld()
    },
    useNew() {
      this.$refs.form.clearValidate()
      this.rules.value[0].required = false
      this.chooseOldVisible = true
      this.formData = { value: '', label: '' }
      this.url = ''
    },
    userOld() {
      this.url = '/ecom/hx/spu/old/collection'
      this.rules.value[0].required = true
      this.chooseOldVisible = false
    },
  },
}
</script>
<style lang="scss" scoped>
.side_frame_warning {
  border-left: 4px solid #fe6c6f;
  margin: 15px 0;
  border-radius: 4px;
}
.side_frame_pri {
  border-left: 4px solid #50bfff;
  margin: 15px 0;
  border-radius: 4px;
}
::v-deep .el-card__header {
  padding: 8px 8px 0px 8px;
  border-bottom: 0px;
}
::v-deep .el-card__body {
  padding: 10px;
}

.span_text_header {
  font-weight: 700;
  font-size: 18px;
}
.span_text_body {
  font-weight: 700;
  font-size: 15px;
}
</style>
